import React, { useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { projectFilesApi } from "../api/projectFiles";
import { roadmakerApi } from "../api/roadmakerApi";

const DownloadFilesOnPhone = () => {
  const { t } = useTranslation();
  const [fileNames, setFileNames] = useState([]);
  const [searchParams] = useSearchParams();
  const projectId = searchParams.get("projectId");

  const handleDownload = (fileName) => {
    axios
      .get(projectFilesApi.download(projectId, fileName), {
        responseType: "blob",
        withCredentials: true,
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
      });
  };

  const handleDownloadAll = () => {
    fileNames.forEach((fileName) => {
      handleDownload(fileName);
    });
  };

  React.useEffect(() => {
    if (!projectId) {
      setFileNames([]);
      return;
    }

    roadmakerApi.files
      .list(projectId)
      .then((files) => setFileNames(files))
      .catch(() => setFileNames([]));
  }, [projectId]);

  return (
    <div className="App d-flex align-items-center justify-content-center vh-100">
      {fileNames.length > 0 ? (
        <div className="d-flex flex-column align-items-center">
          <h6 className="mb-3">{t("downloadInstructions")}</h6>
          <button
            className="btn btn-success mb-2"
            onClick={handleDownloadAll}
            aria-label="Download"
          >
            {t("downloadAll")}
          </button>
        </div>
      ) : (
        <div className="d-flex flex-column align-items-center">
          <h6 className="mb-3">{t("fileNotAvailable")}</h6>
        </div>
      )}
    </div>
  );
};

export default DownloadFilesOnPhone;
